import {postRequest} from "../../src/api/index.js";
import {PAGE_ACCESS, PAGE_ACCESS_ERROR} from "../../src/actions/types.js";
import {getUser} from "../helpers/index";

export const pageAccessLog = async (data, cb) => async (
    dispatch
) => {
    try {
        const user = getUser();

        if (user?.organizationId && user?.organizationId.length > 0 &&
            ((user?.defaultOrbit && user?.defaultOrbit.length > 0) || (user?.selectedOrbit && user?.selectedOrbit.length > 0))) {
            const dataModified = {
                ...data,
                organizationId: user?.organizationId,
                orbitId: user?.defaultOrbit ? user?.defaultOrbit : user?.selectedOrbit
            };

            const res = await postRequest(`/pageAccessLog`, "user", dataModified);

            cb(res.data);
        } else {
            cb();
        }
    } catch (err) {
        if (err.response) {
            // There is an error response from the server
            // You can anticipate error.response.data here
            if (err.response.data && err.response.data.errors[0]) {
                dispatch({
                    type: PAGE_ACCESS_ERROR,
                    payload: err.response.data.errors[0]
                });
            } else {
                const error = err.response.data;
                dispatch({
                    type: PAGE_ACCESS_ERROR,
                    payload: err.message
                });
            }
        } else if (err.request) {
            // The request was made but no response was received
            // Error details are stored in error.reqeust
            dispatch({
                type: PAGE_ACCESS_ERROR,
                payload: err.request
            });
        } else if (err) {
            dispatch({
                type: PAGE_ACCESS_ERROR,
                payload: err.message
            });
        } else {
            // Some other errors
            dispatch({
                type: PAGE_ACCESS_ERROR,
                payload: "Something went wrong."
            });
        }
    }
};
